/**
 * Bildirim sesi: WebAudio ile üretilen kısa, kısık bir ses (dosya yok). Yalnız Görünüm › Bildirimler'de "Ses" açıksa
 * çalar (bildirimTercihi.ses). Türe göre ayrı: başarı yükselen iki nota, uyarı tek nota, hata alçalan iki nota.
 */
import {bildirimTercihiAl, BildirimTuru} from "./bildirimTercihi";

/** her nota: [frekans Hz, süre sn] */
const NOTALAR: Record<BildirimTuru, [number, number][]> = {
    success: [[880, 0.09], [1320, 0.12]],
    warning: [[740, 0.16]],
    error: [[523, 0.12], [392, 0.18]],
};
const SES_DUZEYI = 0.06;
/** aynı anda gelen bildirimler (toplu işlem) art arda öttürmesin */
const ARALIK_MS = 400;

let baglam: AudioContext | null = null;
let sonCalma = 0;

const sesBaglami = (): AudioContext | null => {
    if (baglam) {
        return baglam;
    }
    const Yapici = typeof window !== "undefined"
        ? (window.AudioContext ?? (window as any).webkitAudioContext)
        : undefined;
    if (!Yapici) {
        return null;
    }
    try {
        baglam = new Yapici();
    } catch (e) {
        baglam = null;
    }
    return baglam;
};

/** sesi çal (tercih kapalıysa hiçbir şey yapmaz); `zorla`: tercihe bakmadan (Görünüm'de "Dene") */
export const bildirimSesiCal = (tur: BildirimTuru, zorla = false): void => {
    if (!zorla && !bildirimTercihiAl().ses) {
        return;
    }
    const simdi = Date.now();
    if (simdi - sonCalma < ARALIK_MS) {
        return;
    }
    sonCalma = simdi;
    const ctx = sesBaglami();
    if (!ctx) {
        return;
    }
    try {
        if (ctx.state === "suspended") {
            // tarayıcı kullanıcı hareketi olmadan sesi başlatmaz: olmazsa sessizce geç
            ctx.resume().catch(() => undefined);
        }
        let t = ctx.currentTime + 0.01;
        for (const [frekans, sure] of NOTALAR[tur] ?? NOTALAR.success) {
            const osc = ctx.createOscillator();
            const kazanc = ctx.createGain();
            osc.type = "sine";
            osc.frequency.setValueAtTime(frekans, t);
            // tık sesi olmasın: yumuşak giriş / çıkış
            kazanc.gain.setValueAtTime(0.0001, t);
            kazanc.gain.exponentialRampToValueAtTime(SES_DUZEYI, t + 0.015);
            kazanc.gain.exponentialRampToValueAtTime(0.0001, t + sure);
            osc.connect(kazanc);
            kazanc.connect(ctx.destination);
            osc.start(t);
            osc.stop(t + sure + 0.02);
            t += sure;
        }
    } catch (e) {
        /* ses aygıtı yok / engelli: sessizce geç */
    }
};
